import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
    Button,
    Alert
} from 'reactstrap'
import FileSaver from 'file-saver'
import NotificationService from 'services/NotificationService'

import api from '../api'
import './Export.scss'

class ExportAdditionalQuestions extends Component {

    static propTypes = {
        organisationId: PropTypes.number,
        startdate: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]),
        enddate: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ])
    }

    state = {
        requested: false,
        success: false
    }

    handleClick = async() => {
        const { organisationId, startdate, enddate } = this.props

        try {
            const res = await api.getAdditionalQuestionsExport(organisationId, startdate, enddate)
            if (res && res.data) {
                FileSaver.saveAs(res.data, 'extra_vragen.xlsx')
                this.setState({
                    requested: true,
                    success: true
                })
            } else {
                this.setState({
                    requested: true,
                    success: false
                })
            }
        } catch (err) {
            this.setState({
                requested: false
            }, () =>
                NotificationService.notifyError({
                    title: err.message || 'Fout',
                    message: 'Er heeft een fout opgetreden tijdens het verwerken van het verzoek.'
                })
            )
        } finally {
            window.setTimeout(() => {
                this.setState({
                    requested: false,
                    error: null,
                    success: false
                }) // reset after 10 seconds
            }, 10000)
        }
    }

    render() {
        const isValid = new Date(this.props.startdate) <= new Date(this.props.enddate)

        let color = this.state.requested ?
            this.state.success ? 'success' : 'danger'
            : 'light'

        if (this.state.error) {
            color = 'danger'
        }

        return (
            <div>
                <Button
                    disabled={ !isValid }
                    onClick={ this.handleClick }
                    color={ color }
                >
                Export extra vragen
                </Button>
                { this.state.error && (
                    <div className="mt-1">
                        <Alert color="danger">{ this.state.error }</Alert>
                    </div>
                ) }

            </div>
        )
    }
}

export default ExportAdditionalQuestions
